import { Field } from '.';
import { PointCategory } from '../../../models';

/* istanbul ignore file */
export class Column {
    enum?: string[];
    Fields?: Field[];
    GroupTitle?: string;
    header?: string;
    id: string;
    parentId?: string;
    order?: number;
    row?: number;
    type: string;
    pointCategories?: PointCategory[];
    richTextFormula?: string;
    format?: string;
    decimalPlaces?: number;
    description?: string;
}
